import {
    ContentfulEntryContract,
    ContentfulEntryContractFields,
    ContentfulEntryFromContract,
} from './contracts';

export interface ReleaseNotesContentFields
    extends ContentfulEntryContractFields {
    brand?: string;
    description?: string;
    html?: string;
    learnMoreUrl?: string;
    name?: string;
    title?: string;
    version?: string;
}

export type ReleaseNotesContract = ContentfulEntryContract<
    ReleaseNotesContentFields,
    'releaseNotes'
>;

export type ReleaseNotesContent =
    ContentfulEntryFromContract<ReleaseNotesContract>;

export class ReleaseNotes {
    private contract: Partial<ReleaseNotesContent>;

    constructor(contract: Partial<ReleaseNotesContent> = {}) {
        this.contract = contract;
    }

    get brand(): string {
        return this.contract.fields?.brand ?? '';
    }

    get description(): string {
        return this.contract.fields?.description ?? '';
    }

    get html(): string {
        return this.contract.fields?.html ?? '';
    }

    get learnMoreUrl(): string {
        return this.contract.fields?.learnMoreUrl ?? '';
    }

    get name(): string {
        return this.contract.fields?.name ?? '';
    }

    get title(): string {
        return this.contract.fields?.title ?? '';
    }

    get version(): string {
        return this.contract.fields?.version ?? '';
    }
}
